import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./NotificationsUIHelpers";

const NotificationsUIContext = createContext();

export function useNotificationsUIContext() {
  return useContext(NotificationsUIContext);
}

export const NotificationsUIConsumer = NotificationsUIContext.Consumer;

export function NotificationsUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
  };

  return <NotificationsUIContext.Provider value={value}>{children}</NotificationsUIContext.Provider>;
}
